import { useRecoilState } from "recoil"
import { haveLetterLower, haveLetterUpper, haveNumber, lengthValid } from "src/shared/global/helpers";
import { rulesPasswordState } from "../state/atoms";

const usePasswordValidate = () => {
    const [rulesPassword, setRulesPassword] = useRecoilState(rulesPasswordState)

    const handleValidatePassword = (ev) => {
        const { value } = ev.target;

        setRulesPassword({
            ...rulesPassword,
            lowerCaseLetterIsValid: haveLetterLower(value),
            upperCaseLetterIsValid: haveLetterUpper(value),
            findOneNumberIsValid: haveNumber(value),
            lengthIsValid: lengthValid(value)
        });
    }

    return {
        handleValidatePassword
    }
}

export default usePasswordValidate
